// extracted by mini-css-extract-plugin
export default {"btn":"ButtonMoreVariant_btn__Iq-On","actions":"ButtonMoreVariant_actions__kmnH1","actionItem":"ButtonMoreVariant_actionItem__LUkts","inner":"ButtonMoreVariant_inner__mwWxN"};